export const DA = 'da';
export const EN = 'en';
export const FO = 'fo';
export const KN = 'kn';
export const defaultLocale: typeof DA = 'da';
export const locales = [DA, EN, FO, KN] as const;
export const mainLocales = [DA, EN] as const;
export type Locale = (typeof locales)[number];
export type MainLocale = (typeof mainLocales)[number];
